import {
    graphql,
    requestSubscription
  } from 'react-relay';
  import { ConnectionHandler } from 'relay-runtime';
  import environment from '../../environment';
  
  const subscription = graphql`
    subscription fantasyLeaderboardSubscription ($event_id: ID!) {
        updateFantasyLeadarboard (event_id: $event_id) {
        event_id
      }
    }
  `;
  
  function fantasyLeaderboardSubscription(variables, updater, onNext, onError) {
    return requestSubscription(environment, {
      subscription: subscription,
      variables: variables,
      updater,
      onError,
      onNext
    });
  }
  
  export default fantasyLeaderboardSubscription;